export default __webpack_public_path__ + "static/media/FOTO7.89d339ad.jpg";